module.exports = __webpack_public_path__ + "img/trajet.f1ded349.png";